// @flow

import React from "react";

import FieldControl from "../../FieldControl";
import NumberInput from "../../Input/NumberInput";
import Select, { type SelectOption } from "../../Select";

import { errors } from "../../../utils/errors";
import { combineValidators, required, upperBound, isPositive } from "../../../utils/validators";
import { placeholders } from "../../../utils/placeholders";

type TableRowProps = {
  name: string,
  tableConfig: {
    options: Array<SelectOption>,
    firstColumnFieldName: string,
    secondColumnFieldName: string
  },
  optionsToFilter: Array<string>
};

const TableRow = ({
  name,
  tableConfig: { options, firstColumnFieldName, secondColumnFieldName },
  optionsToFilter
}: TableRowProps) => (
  <tr>
    <td>
      <FieldControl
        name={`${name}.${firstColumnFieldName}`}
        validate={required(errors.requiredSelection())}
        isErrorWrapped
      >
        {({ input }) => (
          <Select
            input={input}
            options={options}
            optionsToFilter={optionsToFilter}
            autoComplete
            placeholder="Bitte wählen"
            popperWidth={200}
          />
        )}
      </FieldControl>
    </td>
    <td>
      <FieldControl
        name={`${name}.${secondColumnFieldName}`}
        validate={combineValidators(
          required(errors.requiredField()),
          upperBound(999999999, errors.maxLengthDigits(9)),
          isPositive(errors.isPositive())
        )}
        isErrorWrapped
      >
        {({ input }) => (
          <NumberInput input={input} sideSymbol={() => "€"} placeholder={placeholders.inEuro} />
        )}
      </FieldControl>
    </td>
  </tr>
);

export default TableRow;
